function supplierKey(supplier) {
  if (!supplier || supplier.pessoa_id == null || supplier.pessoa_id === "") {
    return null;
  }
  return String(supplier.pessoa_id);
}

/**
 * Lista enviada no PATCH de transportadores.
 *
 * O backend inativa quem não vier no payload. `linked` (ativas já gravadas)
 * entra sempre. `pending` (chips desta sessão) entra depois, sem repetir
 * pessoa_id e sem reativar quem já está em `blockedIds`.
 */
export function mergeCarriersForSave(linked, pending, blockedIds = []) {
  const blocked = new Set(
    (Array.isArray(blockedIds) ? blockedIds : []).map((id) => String(id)),
  );
  const merged = [];
  const seen = new Set();

  const push = (supplier, respectBlock) => {
    const key = supplierKey(supplier);
    if (key == null || seen.has(key)) return;
    if (respectBlock && blocked.has(key)) return;
    seen.add(key);
    merged.push(supplier);
  };

  (Array.isArray(linked) ? linked : []).forEach((supplier) => push(supplier, false));
  (Array.isArray(pending) ? pending : []).forEach((supplier) => push(supplier, true));

  return merged;
}
